import React, {Component} from 'react';
import TableHolderCustom from '../visualization/table-holder-custom';
import Spinner from '../generic/spinner';
import Utils from "../../Utils/Utility";
import CustomStore from "../stores/custom-charge-store";

const columns = {
    'name': {type: 'string', label: 'Name'},
    'chargeTag': {type: 'string', label: 'Charge Tag'},
    'chargeType': {type: 'string', label: 'Charge Type'},
    'orderType': {type: 'string', label: 'Order Type'},
    'status': {type: 'string', label: 'Status'},
    'chargeDetail': {type: 'string', label: 'Edit'}
};

const DELIVERY = "Delivery";
const PICKUP = "PickUp";
const CURBSIDEPICKUP = "CurbsidePickUp";
const DINEIN = "DineIn";

export default class CustomChargesView extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            activeLocation: null,
            chargesData      : [],
            isLoaded       : false,
            totalChargesData: 0,
            showAllItemView: false
        };

        this._bind(
            'loadCustomCharges',
            'updateCharge',
            'deleteCharge'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    componentDidMount() {
        // when load the main class get all the data and reload
        this.loadCustomCharges();

    }


    componentWillMount() {

        this.setState({
            activeLocation: this.props.activeLocation,
            chargesData: [],
            totalChargesData: 0
        });
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps !== null) {
            this.setState({
                    activeLocation: nextProps.activeLocation,
                    chargesData: [],
                    totalChargesData: 0,
                },
                () => {
                    this.loadCustomCharges();
                });
        }
    }

    loadCustomCharges() {
        let self = this;

        let chargesDataByOrderType = CustomStore.getCustomCharges();
        if (chargesDataByOrderType != null) {

            chargesDataByOrderType.map((charge) => {

                /* Response Data*/
                let newTable = {};
                Object.keys(columns).forEach(col => {
                    if (col == "name") {
                        newTable[col] = charge.name;
                    } else if (col == "chargeTag") {
                        newTable[col] = charge.tag;
                    }else if (col == "chargeType") {
                        let chargeName = Utils.getChargeFullName(charge.type);
                        newTable[col] = chargeName;
                    }else if (col == "orderType") {
                        let orderTypes = charge.orderTypes;
                        // newTable[col] = orderTypes.toString();
                        let comp = "";
                        orderTypes.forEach(function (item, index) {
                            // console.log(item, index);
                            comp += item + "<br/>";
                        });

                        newTable[col] = <div dangerouslySetInnerHTML={{__html: comp}} />;

                        // return comp;
                        // return <div dangerouslySetInnerHTML={{__html: comp}} />;

                    } else if (col == "status") {
                        let status = charge.active == true ? "Active" : "In-Active";
                        newTable[col] = status;
                    } else if (col == "chargeDetail") {

                        newTable[col] = charge;
                    } else {
                        // newTable[col] = result[col];
                    }
                });

                self.state.chargesData.push(newTable);

            });

            self.setState({
                isLoaded: true,
                totalChargesData: chargesDataByOrderType.length,
                showAllItemView : true
            });


        }
        else {
            self.setState({
                isLoaded: true,
                totalChargesData: 0,
                showAllItemView : true
            });
        }
    }

    updateCharge(chargeDetail){
        this.props.callBackUpdateCharge(chargeDetail);

    }

    deleteCharge(chargeDetail){
        this.props.callBackDeleteCharge(chargeDetail);

    }

    render() {

        // set custom button in the table column
        columns["chargeDetail"] = {
            ...columns.chargeDetail,
            Cell: rowVal => (
                    <div className="dropdown">
                        <button className="dropbtn"><i className="fa fa-ellipsis-h fa-lg" aria-hidden="true"></i></button>
                        <div className="dropdown-content">
                            <a href="JavaScript:void(0);" onClick={_ => this.updateCharge(rowVal.chargeDetail)}>Update</a>
                            <a href="JavaScript:void(0);" onClick={_ => this.deleteCharge(rowVal.chargeDetail)}>Delete</a>
                        </div>
                    </div>
            )
        };

        return (
            <div className="order-pg">
                {!this.state.isLoaded ? <Spinner/> : null}

                {
                    this.state.showAllItemView ? (
                        <div>
                            <div className="col-md-12">
                                {
                                    this.state.totalChargesData > 0 ?
                                        <TableHolderCustom
                                            columns={columns}
                                            tableData={this.state.chargesData}
                                            customClass={"all-item custom-charges-table"}
                                            countDefault={0}

                                        />
                                        :
                                        <div className="col-md-12 text-center">
                                            <h4 className="h-small">No record found
                                            </h4>
                                        </div>
                                }
                            </div>
                        </div>
                    ) : null
                }

            </div>
        );
    }

}





// WEBPACK FOOTER //
// src/components/custom-charges/custom-charges-view.js